import React, { type FC, useState, useRef, useEffect } from 'react'
import Quiz from './Quiz'
import useTimer from '../hooks/useTimer'
import useSaveUserAnswers from '../hooks/useSaveUserAnswers'

const firstAnswer = new URLSearchParams(window.location.search).get('firstAnswer')

const QuizController: FC<any> = ({ quizId, quizData, session }) => {
  const { questions } = quizData.acf_fields

  const lastIndex = useRef(0)
  const [index, setIndex] = useState(0)

  const goToNextQuestion = (): void => {
    setIndex((prev) => {
      const newIndex = prev + 1
      if (lastIndex.current < newIndex) lastIndex.current = newIndex
      return newIndex
    })
  }

  const goToPreviousQuestion = (): void => {
    setIndex((prev) => prev - 1)
  }

  const goToQuestion = (index: number): void => {
    setIndex(index)
  }

  const [userAnswers, setUserAnswers] = useState<IUserAnswer[]>(
    session?.results ??
      questions.map((question: IQuestion, index: number) => {
        if (index === 0 && firstAnswer !== null) {
          return {
            question,
            answers: [question.answers[Number(firstAnswer)]],
          }
        } else return { question, answers: [] }
      })
  )

  const { hours, minutes, seconds, stopTimer } = useTimer(session?.timer ?? null)

  const { save } = useSaveUserAnswers(quizId, userAnswers, `${hours}:${minutes}:${seconds}`)

  const sendResults = (): void => {
    if (session !== null) window.location.replace(session.permalink)
    else save()
  }

  const saveUserAnswer = (userAnswer: IAnswer): void => {
    setUserAnswers((prevUserAnswers) => {
      const newUserAnswers = [...prevUserAnswers]
      newUserAnswers[index].answers.push(userAnswer)
      return newUserAnswers
    })
  }

  useEffect(() => {
    const quizIsFinished = userAnswers.every((userAnswer: IUserAnswer) => userAnswer.answers.length > 0)
    if (quizIsFinished) {
      stopTimer()
    }
  }, [userAnswers])

  return (
    <Quiz
      index={index}
      data={quizData}
      goToPreviousQuestion={goToPreviousQuestion}
      goToNextQuestion={goToNextQuestion}
      goToQuestion={goToQuestion}
      userAnswers={userAnswers}
      saveUserAnswer={saveUserAnswer}
      lastIndex={lastIndex.current}
      timer={{ minutes, seconds }}
      sendResults={sendResults}
      quizId={quizId}
    />
  )
}

export default QuizController
